import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchLeadNotifications, archiveLeadNotifications } from '../api/notifications.js';
import { queryKeys } from '../lib/queryKeys.js';
import { LeadNotificationsList } from './LeadNotificationsList.jsx';

export function LeadJournalPopup ({ leadId, leadName, onClose, onOpenLead }) {
  const qc = useQueryClient();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['notifications', 'lead', leadId],
    queryFn: () => fetchLeadNotifications(leadId),
    enabled: Boolean(leadId),
  });
  const notifications = data?.notifications ?? [];

  const archiveMut = useMutation({
    mutationFn: () => archiveLeadNotifications(leadId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.notifications.all });
      qc.invalidateQueries({ queryKey: ['notifications', 'lead', leadId] });
    },
  });

  const handleNotificationClick = (n) => {
    onClose();
    if (n.type === 'form_submitted' || n.type === 'contract_signed') {
      navigate(`/documents?lead=${leadId}`);
      return;
    }
    const ch = n.channel || n.payload?.channel;
    let initialTab;
    if (ch === 'email') initialTab = 'email';
    else if (ch === 'instagram_wazzup' || ch === 'instagram_native' || ch === 'instagram' || ch === 'wazzup') initialTab = 'instagram';
    if (onOpenLead) onOpenLead(leadId, initialTab);
  };

  useEffect(() => {
    if (leadId) archiveMut.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadId]);

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 1100,
        background: 'rgba(0,0,0,0.35)', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 'min(520px, 92vw)', maxHeight: '80vh', overflow: 'auto',
          background: '#fff', borderRadius: 12, padding: 16,
          boxShadow: '0 12px 40px rgba(0,0,0,0.2)',
        }}
      >
        <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <h3 style={{ margin: 0, fontSize: 16 }}>{leadName || 'Уведомления'}</h3>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              type='button'
              onClick={() => { onClose(); if (onOpenLead) onOpenLead(leadId, 'journal'); }}
            >
              Открыть карточку
            </button>
            <button type='button' onClick={onClose} aria-label='Закрыть'>✕</button>
          </div>
        </header>
        <LeadNotificationsList notifications={notifications} loading={isLoading} onNotificationClick={handleNotificationClick} />
      </div>
    </div>
  );
}
